export default __webpack_public_path__ + "static/media/banner2.889ec19e.png";